import React, { memo } from 'react';
import { BLANK } from '@yme/utils/constants';
import { ImageStyled, SocialIconWrapperStyled } from './styled';
function SocialIconComponent({ link, altText, image, uniqueLabel }) {
    return (React.createElement("a", { href: link, target: BLANK, rel: "noopener", "aria-label": altText || uniqueLabel, "data-testid": uniqueLabel },
        React.createElement(SocialIconWrapperStyled, { justifyContent: "center", alignItems: "center" },
            React.createElement(ImageStyled, { width: 16, height: 16, maxHeight: "16px", src: image, alt: altText }))));
}
export const SocialIcon = memo(SocialIconComponent);
SocialIcon.displayName = 'Social_icon_component';
